import React from 'react'

import { Box, FlexBox, useScreenClass } from '@vp/swan'

import ProductName from '../../../root/ProductName'
import { useProject } from '../../../root/contexts/ProjectContext'
import { ConnectedSizedGoodQuantitySelector } from './ConnectedSizedGoodQuantitySelector'
import { ConnectedHardGoodQuantitySelector } from './ConnectedHardGoodQuantitySelector'
import { useAppState } from '../../../root/contexts/AppContext'
import { ColorName } from '../../colorOption/ColorName'
import SizeChartModal from '../SizeChart/SizeChartModal'
import ProjectTools from '../ProjectTools/ProjectTools'

const ConnectedQuantitySelectorWrapper: React.FC = () => {
  const { isSizedGood, isPrimaryProject, productName } = useProject()
  const { primaryProject } = useAppState()
  const screenClass = useScreenClass()

  return (
    <>
      <Box>
        <FlexBox
          className="qsp-project-quantity-section qsp-project-quantity-section-title-and-tools"
          justifyContent="space-between"
          flexDirection={screenClass === 'xs' ? 'column' : null}
        >
          <Box paddingY={{ xs: 4, sm: 0 }}>
            <ProductName renderAs="h2" />
            {!isPrimaryProject && primaryProject?.productName === productName && screenClass === 'xs' && <ColorName mb={{ md: 4 }} />}
          </Box>
          <ProjectTools />
        </FlexBox>
        {!isPrimaryProject && primaryProject?.productName === productName && screenClass !== 'xs' && (
          <ColorName className="qsp-project-quantity-section" mb={{ md: 4 }} />
        )}
      </Box>
      {isSizedGood ? (
        <>
          <ConnectedSizedGoodQuantitySelector />
          <SizeChartModal />
        </>
      ) : (
        <ConnectedHardGoodQuantitySelector />
      )}
    </>
  )
}

export default ConnectedQuantitySelectorWrapper
